import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "house-card" }
const _hoisted_2 = { class: "house-image-wr" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "house-details" }
const _hoisted_5 = { class: "house-title" }
const _hoisted_6 = { class: "house-features-wr" }
const _hoisted_7 = { class: "house-price" }
const _hoisted_8 = { class: "lot-details" }
const _hoisted_9 = { class: "lot-item" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "lot-item" }
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "lot-item" }
const _hoisted_14 = { class: "value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "hover-overlay" }, [
      _createElementVNode("button", {
        class: "view-floor-plan",
        onClick: $setup.handleViewFloorPlan
      }, "View Design")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: $setup.props.house.mainImages[0]
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString($setup.props.house.name), 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString($setup.formatPrice($setup.props.house.basePrice)), 1),
        _createVNode($setup["HouseFeatures"], {
          features: $setup.props.house,
          class: _normalizeClass('house-features'),
          iconSize: 'tiny'
        }, null, 8, ["features"])
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "divider" }, null, -1)),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "label" }, "Min. Frontage:", -1)),
          _createElementVNode("span", _hoisted_10, _toDisplayString($setup.formatMeters($setup.props.house.width, false)) + " m", 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "label" }, "Min. Depth:", -1)),
          _createElementVNode("span", _hoisted_12, _toDisplayString($setup.formatMeters($setup.props.house.length, false)) + " m", 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "label" }, "Size:", -1)),
          _createElementVNode("span", _hoisted_14, _toDisplayString($setup.formatMeters($setup.props.house.area, false)) + " sqm", 1)
        ])
      ])
    ])
  ]))
}